import { createTheme, Theme } from '@fluentui/react';

// Fluent themes for the add-in. The dark theme is built with isInverted so
// Fluent derives correct semantic colors (panel/dialog/input/menu/list
// backgrounds and text) from the palette - no .dark-mode .ms-* CSS patches.
// Custom (non-Fluent) styling still uses the CSS variables toggled by the
// body's light-mode/dark-mode class.

export const lightTheme: Theme = createTheme({
  palette: {
    themePrimary: '#0078d4',
    themeLighterAlt: '#f3f9fd',
    themeLighter: '#d0e7f8',
    themeLight: '#a9d3f2',
    themeTertiary: '#5ca9e5',
    themeSecondary: '#1a86d9',
    themeDarkAlt: '#006cbe',
    themeDark: '#005ba1',
    themeDarker: '#004377',
    neutralLighterAlt: '#faf9f8',
    neutralLighter: '#f3f2f1',
    neutralLight: '#edebe9',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c6c4',
    neutralTertiary: '#a19f9d',
    neutralSecondary: '#605e5c',
    neutralPrimaryAlt: '#3b3a39',
    neutralPrimary: '#323130',
    neutralDark: '#201f1e',
    black: '#000000',
    white: '#ffffff',
  },
});

export const darkTheme: Theme = createTheme({
  isInverted: true,
  palette: {
    themePrimary: '#4da6ff',
    themeLighterAlt: '#03090f',
    themeLighter: '#0d253d',
    themeLight: '#194573',
    themeTertiary: '#3189e6',
    themeSecondary: '#479ef5',
    themeDarkAlt: '#5fb0ff',
    themeDark: '#79bfff',
    themeDarker: '#9ed1ff',
    neutralLighterAlt: '#2b2b2b',
    neutralLighter: '#333333',
    neutralLight: '#414141',
    neutralQuaternaryAlt: '#4a4a4a',
    neutralQuaternary: '#515151',
    neutralTertiaryAlt: '#6f6f6f',
    neutralTertiary: '#c8c8c8',
    neutralSecondary: '#d0d0d0',
    neutralPrimaryAlt: '#dadada',
    neutralPrimary: '#e4e4e4',
    neutralDark: '#f4f4f4',
    black: '#f8f8f8',
    white: '#1f1f1f',
  },
});
